import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: () => import('@/views/Landing.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { guest: true }
  },
  {
    path: '/app',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('@/views/Settings.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/contacts',
    name: 'Contacts',
    component: () => import('@/views/Contacts.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/profile/:email',
    name: 'Profile',
    component: () => import('@/views/Profile.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/app'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Cross-subdomain Better Auth session check
async function checkBetterAuth(): Promise<boolean> {
  try {
    const res = await fetch('https://kuos.ai/api/auth/get-session', {
      credentials: 'include',
      headers: { 'Accept': 'application/json' }
    })
    if (res.ok) {
      const session = await res.json()
      return !!session?.user
    }
  } catch {}
  return false
}

router.beforeEach(async (to, _from, next) => {
  const authStore = useAuthStore()

  if (to.meta.guest && authStore.isAuthenticated) {
    return next('/app')
  }

  if (to.meta.requiresAuth) {
    if (authStore.isAuthenticated) {
      return next()
    }
    // Try Better Auth cross-subdomain session
    const hasSession = await checkBetterAuth()
    if (hasSession) {
      await authStore.fetchUser()
      return next()
    }
    return next('/login')
  }

  next()
})

export default router
